import { Box } from '@mui/material';
import React, { FC, } from 'react';
import FormControler from './FormControler';
import { useTour } from '../../provider/TourGuide';


interface CardProps {
    item: IPermissionDetailed
    isEditable: boolean
}


const Card:FC<CardProps> = ({item,isEditable}) => {
    const {bussniesNumber} = useTour()
    return (
        <Box sx={{padding:'0 10px'}}>
            <FormControler 
                item={item}
                field={'isArchitecture'}
                fieldDb={'isArchitecture'}
                checkedValue={item.isArchitecture}
                title={'פתיחת הרשאות לעובדים'}
                description={' העובד יוכל להוסיף הרשאות לעובדים אחרים'}
                isEditable={isEditable}
            />
            <FormControler 
                item={item}
                field={'orderable'}
                fieldDb={'isOrderable'}
                checkedValue={item.isOrderable}
                title={'ביצוע הזמנה'}
                description={'ההרשאה מאפשרת לבצע הזמנה חדשה וכן לשחזר הזמנה קודמת'}
                isEditable={isEditable}
            />
 
            <FormControler 
                item={item}
                field={'orderEditable'}
                fieldDb={'isOrderEditable'}
                checkedValue={item.isOrderEditable}
                title={'עדכון וביטול הזמנה'}
                description={'ההרשאה מאפשרת לעדכן ולבטל הזמנה, בהתאם לסטטוס'}
                isEditable={isEditable}
            />
            {bussniesNumber !== 2 &&
            <>
                <FormControler 
                    item={item}
                    field={'serviceable'}
                    fieldDb={'isServiceable'}
                    checkedValue={item.isServiceable}
                    title={'פתיחת קריאת שירות'}
                    description={'ההרשאה מאפשרת לפתוח קריאת שירות חדשה למכונה'}
                    isEditable={isEditable}
                />

                <FormControler 
                    item={item}
                    field={'serviceEditable'}
                    fieldDb={'isServiceEditable'}
                    checkedValue={item.isServiceEditable}
                    title={'ביטול ועריכת קריאת שירות'}
                    description={'ההרשאה מאפשרת לבטל ולערוך קריאת שירות בהתאם לסטטוס'}
                    isEditable={isEditable}
                />
                <FormControler 
                    item={item}
                    field={'ordersView'}
                    fieldDb={'isOrdersView'}
                    checkedValue={item.isOrdersView}
                    title={'צפיה בארכיון הזמנות'}
                    description={'ההרשאה מאפשרת לצפות בהזמנות קודמות אשר סופקו לבית העסק'}
                    isEditable={isEditable}
                />

                <FormControler 
                    item={item}
                    field={'serviceView'}
                    fieldDb={'isServiceView'}
                    checkedValue={item.isServiceView}
                    title={'צפיה בארכיון קריאות שירות'}
                    description={'ההרשאה מאפשרת לצפות בקריאות שירות קודמות אשר טופלו'}
                    isEditable={isEditable}
                />
                <FormControler 
                    item={item}
                    field={'deliveryView'}
                    fieldDb={'isDeliveryView'}
                    checkedValue={item.isDeliveryView}
                    title={'צפיה בארכיון תעודות משלוח'}
                    description={' ההרשאה מאפשרת לצפות בתעודות משלוח בגין הזמנות שסופקו'}
                    isEditable={isEditable}
                />
                <FormControler 
                    item={item}
                    field={'accounting'}
                    fieldDb={'isAccounting'}
                    checkedValue={item.isAccounting}
                    title={'צפיה ב"כספים"'}
                    description={'ההרשאה מאפשרת לצפות בחשבוניות מס מרכזות, חשבוניות עסקה וקבלות'}
                    isEditable={isEditable}
                />
                
                </>
            }

        </Box>
    );
};

export default Card;